import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IsoCountry } from '../../address/models/isoCountry';
import { BaseService } from '../../_shared/services/base.service';

@Injectable({
  providedIn: 'root',
})
export class CountryService extends BaseService<IsoCountry, IsoCountry> {
  constructor(
    protected override http: HttpClient,
    @Inject('BASE_URL') protected override baseUrl: string
  ) {
    super(http, baseUrl, 'isocountry');
  }

  getAllPublic(orderby?: string): Observable<IsoCountry[]> {
    return this.http
      .get<IsoCountry[]>(this.baseUrl + this.controller + '/public?orderby=' + orderby)
      .pipe(catchError(this.handleError<IsoCountry[]>([])));
  }
}
